import { queryResponse, sibaAuthApi } from "../../backends/sibaApis";
import { IUser } from "../../../models/Home/IUser";
import { userManagementUtil } from "@siba/utilities";

const api = "api/User";
/***
 * Service definition for User setup
 *  */
const UserApi = sibaAuthApi.injectEndpoints({
    //endpoints: (builder) => SibaBackendBaseEndpoints<IUser>('Userconfiguration', builder)
    endpoints: (builder) => ({
        /**
         * Update  endpoint
         * query expects object of type country model.
         * id field is destructure and passed as a query parameter.
         */
        updateUser: builder.mutation<queryResponse<number>, IUser>({
            query: ({ id, ...rest }: any) => ({
                url: `${api}`,
                method: "PUT",
                // body: { ${}id, ...rest },
                data: { id, ...rest }
            })
        }),
        /**
         * Remove  endpoint
         * query expects object with parameters id and modified by (string).
         * id and modifiedby propertied destructured and passed as a query parameter.
         */
        removeUser: builder.mutation<queryResponse<number>, IUser>({
            query: ({ id, modifiedBy }: any) => ({
                url: `${api}/${id}/${modifiedBy}`,
                method: "DELETE"
            })
        }),
        /**
         * Sample query method using rtk mutation instead of rtk query.
         */
        getAllUser: builder.mutation<IUser[], void>({
            query: () => ({
                url: `${api}`,
                method: "GET"
            })
        }),
        /***
         *  Search  Endpoint
         *  using rtk mutations instead of rtk for search.
         * @param query search form object of type ISearchForm.
         */
        searchUser: builder.mutation<queryResponse<IUser[]>, any>({
            query: (query: any) => ({
                url: `${api}/search`,
                method: "POST",
                // body: query,
                data: query
            })
        }),
        /**
         * Enpoint to register new user Account.
         */
        signUp: builder.mutation<queryResponse<any>, IUser[]>({
            query: (obj: IUser[]) => ({
                url: `${api}/signup`,
                method: "POST",
                data: obj[0]
            })
        }),
        /**
         * Update  endpoint
         * query expects object of type country model.
         * id field is destructure and passed as a query parameter.
         */
        updatePassword: builder.mutation<queryResponse<IUser>, IUser>({
            query: (data: any) => ({
                url: `${api}`,
                method: "PUT",
                data
            })
        }),

        toggleUserState: builder.mutation<queryResponse<IUser>, IUser>({
            query: (data: IUser) => ({
                url: `${api}/toggle/${data.id}/${userManagementUtil.getUserCode()}`,
                method: "POST",
                data
            })
        }),
        /**
         * Endpoint to fetch the list of values for the user
         * where code fielf is user code
         */
        getUserLovCode: builder.mutation<IUser[], void>({
            query: () => ({
                url: `${api}/lov?code=true`,
                method: "GET"
            })
        }),
        /**
         *  Endpoint to fetch the list of values for the user
         * where code fielf is user id
         */
        getUserLovGuid: builder.mutation<IUser[], void>({
            query: () => ({
                url: `${api}/lov`,
                method: "GET"
            })
        })
    })
});

export const {
    useUpdatePasswordMutation,
    useToggleUserStateMutation,
    useGetAllUserMutation,
    useRemoveUserMutation,
    useSearchUserMutation,
    useUpdateUserMutation,
    useGetUserLovCodeMutation,
    useSignUpMutation,
    useGetUserLovGuidMutation
} = UserApi;
